'use strict';

require('./EmailConfirmed.scss');

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
    apiAppUrl = process.env.URL_API,
    mui = require('material-ui'),
    {RaisedButton} = mui;

const About = React.createClass({displayName: "About",

    handlerClick: function () {
        window.location = apiAppUrl + '/#/login';
    },

    render: function () {
        return (
            React.createElement("div", {className: "welcome-page-container jumbotron"}, 
                React.createElement("div", {className: "container text-center"}, 
                    React.createElement("h1", {className: "welcome-page-container__header light"}, 
                        "Your email has been confirmed. Welcome to BrewPlanner!"
                    ), 
                    React.createElement("div", {className: "welcome-page-container__body"}, 
                        React.createElement("p", null, 
                            t('welcome_message_help_you_planning')
                        ), 
                        React.createElement("br", null), 
                        React.createElement("p", null, 
                            t('welcome_check_out_video_tutorials'), 
                            ' ', React.createElement("a", {
                            target: "_blank", 
                            href: "http://www.brewplanner.com/videos"
                        }, 
                            t('welcome_label_here')
                        ), 
                            ` ${t('welcome_get_started')}`
                        )
                    ), 
                    React.createElement("br", null), 
                    React.createElement("div", {className: "welcome-page-container__start-button"}, 
                        React.createElement(RaisedButton, {
                            label: t('welcome_label_start'), 
                            primary: true, 
                            onTouchTap: this.handlerClick}
                        )
                    ), 
                    React.createElement("br", null), 
                    React.createElement("br", null), 
                    React.createElement("br", null), 
                    React.createElement("img", {
                        style: {height: '60px'}, 
                        src: "/assets/images/logo-small-dark.png"}
                    )
                )
            )
        );
    }
});

module.exports = About;



/** WEBPACK FOOTER **
 ** ./src/views/EmailConfirmed/EmailConfirmed.jsx
 **/